import { render } from "./RequestDetail.vue?vue&type=template&id=52ae322a&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=js"
export * from "./RequestDetail.vue?vue&type=script&lang=js"

import "./RequestDetail.vue?vue&type=style&index=0&id=52ae322a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ae322a"]])

export default __exports__